import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { useEffect, useState } from 'react';
import Logger from '../lib/Logger';
const LOG = Logger.getLogger('LoginClient');
const getGoogleNonceFromLoginApi = () => {
  return noAuthApiClient.post('/login-api/v1/google/init', {
    data: {
      rememberLogin: true
    }
  });
};
export const useGoogleLoginNonce = () => {
  const [googleSignInNonce, setGoogleSignInNonce] = useState();
  useEffect(() => {
    getGoogleNonceFromLoginApi().then(({
      nonce
    }) => {
      setGoogleSignInNonce(nonce);
    }).catch(e => {
      LOG.warn(`Failed to retrieve nonce parameter for Google from login: ${e}`);
    });
  }, []);
  return googleSignInNonce;
};